import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  CardHeader,
  CardContent,
  Stack,
  Button,
  Box,
  Divider,
  TextField,
  Checkbox,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import errorHandler from "../../utils/errorHandler";
import CardLayout from "../../layouts/CardLayout";
import ApiService from "../../services/categoryManagementApi";
import moment from "moment";
import { toast } from "react-toastify";

const { customerQueryApi } = ApiService;

const CustomerQueryView = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [message, setMessage] = useState("");
  const [resolved, setResolved] = useState(false);
  const [error, setError] = useState({ message: false, checkbox: false });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await customerQueryApi.getOneSupport({ id });
        setData(response?.data?.data || {});
        setResolved(response?.data?.data?.queryStatus === "resolved");
        setMessage(response?.data?.data?.message)
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  const handleSendMessage = async () => {
    const validationErrors = {
      message: !message?.trim(),
      checkbox: !resolved,
    };

    if (validationErrors.message || validationErrors.checkbox) {
      setError(validationErrors);
      return;
    }
    setLoading(true);
    setError({ message: false, checkbox: false });

    try {
        const payload = {
            id,
            status: resolved ? "resolved" : "pending",
            message: message.trim()
        }
        const response = await customerQueryApi.resolveQuery(payload);
        if(response.status == 200){
            setMessage("");
            setResolved(false);
            toast.success(response?.data?.message, {toastId: "success"});
            navigate(-1);
            setLoading(false);
        }
    } catch (error) {
      errorHandler(error);
    }
  };


  return (
    <Box>
      <Helmet>
        <title>Customer Query Management</title>
      </Helmet>
      <CardLayout>
        <CardHeader title="Customer Query View" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 4, borderRadius: 3, overflow: "hidden" }}>
                <CardContent>
                  <Stack spacing={2}>
                    <Typography variant="h6">Name</Typography>
                    <Typography variant="body1">{data?.name || "N/A"}</Typography>
                    <Divider />

                    <Typography variant="h6">Subject</Typography>
                    <Typography variant="body1">{data?.subject || "N/A"}</Typography>
                    <Divider />

                    <Typography variant="h6">Description</Typography>
                    <Typography variant="body1">{data?.description || "N/A"}</Typography>
                    <Divider />

                    <Typography variant="h6">Date</Typography>
                    <Typography variant="body1">
                      {data?.createdAt ? moment(data.createdAt).format("DD/MM/YYYY") : "N/A"}
                    </Typography>
                    <Divider />

                    <Typography variant="h6">Time</Typography>
                    <Typography variant="body1">
                      {data?.createdAt ? moment(data.createdAt).format("hh:mm A") : "N/A"}
                    </Typography>
                    <Divider />

                    <Typography variant="h6">Message</Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                     disabled={data?.queryStatus == "resolved"}
                      placeholder="Enter your message..."
                      value={message}
                      onChange={(e) => {
                        setError((prev) => ({ ...prev, message: "" }))
                        setMessage(e.target.value)}}
                      error={error.message}
                      helperText={error.message ? "Message is required" : ""}
                    />
                    <Divider />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={resolved}
                           disabled={data?.queryStatus == "resolved"}
                          onChange={(e) => {
                            setResolved(e.target.checked); 
                            setError((prev) => ({ ...prev, checkbox: false }));
                          }}
                        />
                      }
                      label="Mark as Resolved"
                    />

                    {error.checkbox && (
                      <FormHelperText sx={{ color: "red", mt: "-5px !important" }}>
                      You must mark this query as resolved.
                    </FormHelperText>
                    )}

                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                      <Button variant="contained" color="primary" onClick={handleSendMessage} disabled={loading || data?.queryStatus == "resolved"}>
                      {loading ? "Sending..." : "Send"}
                      </Button>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default CustomerQueryView;
